/*
 * @Author: Cphayim
 * @Date: 2020-01-07 10:46:43
 * @LastEditTime: 2022-02-28 22:34:26
 * @Description: 导出所有路由
 */

import NotFound from '@/render/views/404'

import HomePage from '@/render/views/home'
// import GradingPage from '@/render/views/grading'
// import GradingReplayPage from '@/render/views/grading/replay'

// const HomePage = () => import('@/render/views/home')
// const GradingPage = () => import('@/render/views/grading')
// const GradingReplayPage = () => import('@/render/views/grading/replay')

import authRouter from './auth.router'
import personalRouter from './personal.router'

// 根路由
const rootRoute = authRouter[0]

export default [
  rootRoute,
  /* start: 路由配置数组 eg. ...routesArr */
  {
    path: '/home',
    name: 'Home',
    component: HomePage,
    meta: {
      title: '国际象棋 - 首页',
      index: 0,
      keepAlive: false,
      auth: true,
    },
  },
  {
    path: '/grading',
    name: 'Grading',
    component: resolve => require.ensure([], () => resolve(require('@/render/views/grading')), 'grading'),
    meta: {
      title: '国际象棋 - 定级',
      index: 0,
      keepAlive: false,
      auth: true,
    },
  },
  {
    path: '/grading/replay',
    name: 'GradingReplay',
    component: resolve => require.ensure([], () => resolve(require('@/render/views/grading/replay')), 'grading'),
    meta: {
      title: '国际象棋 - 复盘',
      index: 0,
      keepAlive: false,
      auth: true,
    },
  },
  ...personalRouter,
  ...authRouter,
  /* end: 路由配置数组 */
  // 兜底 404 页面
  {
    name: 'NotFound',
    path: '*',
    component: NotFound,
  },
]
